import React from "react";
import Spinner from "./Spinner";

const ButtonActionDetailGroup = (props) => {
  return (
    <div className="d-flex flex-column flex-md-row justify-content-end">
      {props.children}
    </div>
  );
};

const Button = (props) => {
	const className = `${props.className || ''} mr-1 mb-1`
	return <button {...props} className={className} />
}

const ButtonLoading = (props) => {
	return <Button {...props} >
		<Spinner />
	</Button>
}

ButtonActionDetailGroup.Item = Button;
ButtonActionDetailGroup.Loading = ButtonLoading;

export default ButtonActionDetailGroup;